import type { Timeout } from 'ahooks/lib/useRequest/src/types'
import { useRef } from 'react'
import { useContext } from 'use-context-selector'

import { PreviewMode } from 'services/Store/Project/enums'
import { t } from 'services/Translation'

import TestGroupingContext from '../../TestGroupingContext'
import Result from '../Result'
import MobileAnswerStack from './MobileAnswerStack'
import * as s from './MobileElement.module.scss'
import MobileGroup from './MobileGroup'

const MobileElement = () => {
  const {
    styles,
    shuffledAnswers,
    destination,
    validationMap,
    blockResult,
    mode,
    value,
    setDestination,
    setShuffledAnswers,
    setTestResult,
  } = useContext(TestGroupingContext)
  const ref = useRef<number | null | Timeout>()
  const isAnimating = useRef(false)
  const isEditor = mode.previewMode === PreviewMode.editor
  const answers = value.items.flatMap((group) => group?.items || [])

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isAnimating.current && shuffledAnswers.length && !blockResult) {
      if (ref.current) {
        clearTimeout(ref.current as number)
      }

      const destId = (e.target as Element).id
      if (!destId) {
        return
      }

      isAnimating.current = true

      const answer = shuffledAnswers[0]

      setTestResult((prev) => ({
        ...prev,
        [answer.value]: validationMap[answer.value] === destId,
      }))

      setDestination((prev) =>
        prev.map((group) => ({
          ...group,
          items: group.value === destId ? [...(group.items || []), answer] : group.items,
        })),
      )

      const shuffled = shuffledAnswers.filter((e) => e.value !== answer.value)

      ref.current = setTimeout(() => {
        isAnimating.current = false
        setShuffledAnswers(shuffled)
      }, 400)
    }
  }

  return (
    <div className={s.root} style={{ gap: styles.indents.marginTop }}>
      {shuffledAnswers.length === 0 &&
        answers.length !== 0 &&
        (!!blockResult || isEditor) &&
        value.showResult && <Result />}
      {!answers.length && (
        <div className={s.emptyAnswer} style={{ ...styles.common }}>
          {t('elements.testGrouping.emptyAnswer')}
        </div>
      )}
      {shuffledAnswers.length > 0 && (
        <div className={s.answers}>
          <MobileAnswerStack answers={shuffledAnswers} />
        </div>
      )}
      <div className={s.groups} onClick={onClick} style={{ gap: styles.indents.gap }}>
        {destination.map((item) => (
          <MobileGroup group={item} key={item.value} />
        ))}
      </div>
    </div>
  )
}

export default MobileElement
